import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    function onClick1() {
        this.props.buttonClick(this.props.rightButtonText);
    }
    function onClick2() {
        this.props.buttonClick(this.props.leftButtonText);
    }
    return React.createElement('div', { 'className': 'message-window-base' }, React.createElement('div', { 'className': 'message-error-message-title' }, this.props.errorBox.title || 'Error'), React.createElement('div', { 'className': 'message-red-lable' }), React.createElement('div', { 'className': 'message-system-text message-system-text-red' }, '\r\n    ', this.props.errorBox.text, '\r\n  '), this.props.errorBox.isRightButtonVisible ? React.createElement('div', {
        'className': 'message-system-dismiss-button-wrapper message-system-dismiss-button-setting',
        'onClick': onClick1.bind(this),
        'key': '270'
    }, React.createElement('div', { 'className': 'message-error-dismiss-button' }, '\r\n      ', this.props.errorBox.rightButtonText, '\r\n    ')) : null, this.props.errorBox.leftButtonVisible ? React.createElement('div', {
        'className': 'message-system-dismiss-button-wrapper message-system-dismiss-button-setting-left',
        'onClick': onClick2.bind(this),
        'key': '602'
    }, React.createElement('div', { 'className': 'message-error-dismiss-button' }, '\r\n      ', this.props.errorBox.leftButtonText, '\r\n    ')) : null);
}